import script from "./seachInput.vue?vue&type=script&setup=true&lang=js"
export * from "./seachInput.vue?vue&type=script&setup=true&lang=js"

import "./seachInput.vue?vue&type=style&index=0&id=24d1495e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24d1495e"]])

export default __exports__